
export const openModal = (modalID, props) => ({
  type: 'OPEN_MODAL',
  payload: { modalID, props }
})

export const closeModal = (modalID) => ({
  type: 'CLOSE_MODAL',
  payload: modalID
})



// WEBPACK FOOTER //
// ./src/actions/ui/modals.js